import * as member from 'services/member';

export const MEMBER_DIVISION = 'MEMBER_DIVISION';
export const MEMBER_AUTH = 'MEMBER_AUTH';
export const MEMBER_GROUP = 'MEMBER_GROUP';
export const MEMBER_USER_INFO = 'MEMBER_USER_INFO';
export const MEMBER_RANK_POSITION = 'MEMBER_RANK_POSITION';
export const MEMBER_CLEAN = 'MEMBER_CLEAN';

export const MemberDivision = (params) => ({
  type: MEMBER_DIVISION,
  payload: {
    promise: member.geMemberDivision()
  }
});

export const MemberAuth = (params) => ({
  type: MEMBER_AUTH,
  payload: {
    promise: member.getMemberAuth()
  }
});

export const MemberGroup = (params) => ({
  type: MEMBER_GROUP,
  payload: {
    promise: member.getMemberGroup()
  }
});

export const MemberUserInfo = (params) => ({
  type: MEMBER_USER_INFO,
  payload: {
    promise: member.getMemberUserInfo(params)
  }
});
export const MemberRankPosition = (params) => ({
  type: MEMBER_RANK_POSITION,
  payload: {
    promise: member.getMemberRankPosition()
  }
});

export const MemberClean = (params) => ({
  type: MEMBER_CLEAN,
});
